import React from "react";
import EventBanner from "../../../../components/sections/front/EventBanner";
import EventSection from "../../../../components/sections/front/EventSection";

const Events = () => {
  
  return (
    <>
      <EventBanner/>
      <EventSection/>
    </>
  );
};

export default Events;